/**
 * 「AI エージェントをつなぐ」の画面（/connect）の日本語の文言（2026-10-07 console/connect-again・en.connect.ts と同じキー）。
 * 日本語は既定で出さない（languages.ts）が、型で en と同じキーを持つ
 */
import type { enConnect } from './en.connect';

export const jaConnect: Record<keyof typeof enConnect, string> = {
  'connect.topbarLink': 'AIエージェントをつなぐ',
  'connect.title': 'AIエージェントをつなぐ',
  'connect.lead': '新しいパソコン、別のAIエージェント（Claude Code・Codex・Cursor など）、ウェブで使うAIエージェントで使い始めるときは、下の1行を使ってください。',
  'connect.elsewhereLink': '別のAIエージェントや別のパソコンで{product}を使う'
};
